import { Box, Flex, Menu, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons';
import { useContext, useEffect } from 'react';
import SyncContext from '../../../../context/SyncContext';
import { useCustomerTableData } from '../useCustomerTableData';
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext';


interface DropdownMenuItem {
  label: string;
  index: number;
  groupBy: string;
  icon?: boolean;
}

export function HeaderCell() {
  const { groupBy, setGroupBy } = useCustomerTableData();
  const { threeSixtyConfig, setThreeSixtyConfig, isSingleSelection } = useContext(SingleCustomerContext);

  const dropdownMenu: DropdownMenuItem[] = threeSixtyConfig?.dropdownMenu || [];

  const currentDropdown = dropdownMenu.find(item => item.groupBy === groupBy) || dropdownMenu[0];

  const handleGroupChange = (newGroup: string) => {
    // Update local state first
    setGroupBy(newGroup);
    
    // Then update the context
    if (threeSixtyConfig) {
      setThreeSixtyConfig({
        ...threeSixtyConfig,
        groupBy: newGroup
      });
    }
  };

  // Sync with threeSixtyConfig changes
  useEffect(() => {
    if (threeSixtyConfig?.groupBy && threeSixtyConfig.groupBy !== groupBy) {
      setGroupBy(threeSixtyConfig.groupBy);
    }
  }, [threeSixtyConfig]);

  const getGroupingLabel = () => {
    return currentDropdown?.label || 'Domain';
  };

  const menuItems = dropdownMenu
    .filter(item => !isSingleSelection || item.groupBy !== 'demand')
    .filter(item => item.groupBy !== groupBy)
    .sort((a, b) => a.index - b.index);

  return (
    <Box 
      component="span" 
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        gap: '8px',
      }}
    >
      <Flex>
        <Text fw={600} fz={14} mr={4}>Group by</Text>
        <Menu>
          <Menu.Target>
            <Flex sx={{ cursor: 'pointer' }}>
              <Text fz={14} fw={400} mr={3}>
                {getGroupingLabel()}
              </Text>
              <IconChevronDown size={14} fill='black' />
            </Flex>
          </Menu.Target>
          <Menu.Dropdown>
            {menuItems.map(item => (
              <Menu.Item 
                key={item.groupBy}
                onClick={() => handleGroupChange(item.groupBy)}
              >
                {item.label}
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Flex>
    </Box>
  );
} 